
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import SalePricesForm from '@/components/proposal/form/SalePricesForm.vue';
import AddSurchargeModal from '@/components/proposal/form/AddSurchargeModal.vue';
import OutlineButton from '@/components/ui/OutlineButton.vue';
import { ProposalMutation } from '@/store/proposal/proposal.mutation';

export default defineComponent({
  name: 'ProposalCreateSurcharges',
  components: { SalePricesForm, AddSurchargeModal, OutlineButton },
  data() {
    return {
      showAddSurchargeModal: false
    };
  },
  computed: {
    ...mapGetters(['surchargesRows', 'isProposalEditable']),
    grossMarginMutation(): string {
      return ProposalMutation.SETUP_SURCHARGES_GROSS_MARGIN;
    },
    proposalId(): string {
      const id = this.$route.params.proposalId;
      return Array.isArray(id) ? id[0] : id;
    }
  }
})
